import { render, staticRenderFns } from "./app_main.vue?vue&type=template&id=75271efe&scoped=true"
import script from "./app_main.vue?vue&type=script&lang=js"
export * from "./app_main.vue?vue&type=script&lang=js"
import style0 from "./app_main.vue?vue&type=style&index=0&id=75271efe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75271efe",
  null
  
)

export default component.exports